// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '@tcp/core/src/utils/labels/labelUtilty';
import labelsObj from '@tcp/core/src/components/features/account/Payment/Payment.labels';
import {
  GLOBAL_ACTIONS_LABELS,
  GlobalActionsLabels,
  lblBack,
} from '@tcp/core/src/utils/labels/globalActions.labels';
import withStyles from '../../../../../../common/hoc/withStyles';
import BodyCopy from '../../../../../../common/atoms/BodyCopy';
import Row from '../../../../../../common/atoms/Row';
import Col from '../../../../../../common/atoms/Col';
import styles from '../../../styles/Payment.style';
import Notification from '../../../../../../common/molecules/Notification';
import CreditCardList from '../../CreditCardList.view';
import GiftCardList from '../../GiftCardList.view';
import VenmoCardList from '../../VenmoCardList.view';
import Offers from '../../../../common/molecule/Offers/views/Offers.view';
import DeleteCardModal from '../../DeleteCardModal';
import Anchor from '../../../../../../common/atoms/Anchor';

export class PaymentView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedCard: {},
    };
    this.paymentGCLabels =
      getLabelFromCopyOrFromTranslation('account.paymentGC', labelsObj) ||
      labelsObj.account.paymentGC;
  }

  setSelectedCard = (card) => {
    this.setState({
      selectedCard: card,
    });
  };

  renderDeleteModal = () => {
    const { selectedCard } = this.state;
    const {
      deleteModalMountedState,
      onDeleteCard,
      setDeleteModalMountState,
      showUpdatedNotificationOnModal,
      newGlobalErrorMessageEnabled,
    } = this.props;

    const isCreditCard = selectedCard.ccType !== 'GiftCard' && selectedCard.ccType !== 'VENMO';
    const isVenmo = selectedCard.ccType === 'VENMO';
    let cardHeading = '';
    if (isCreditCard) {
      cardHeading = renderLabel(
        this.paymentGCLabels.lbl_payment_modalDeleteCard,
        'lbl_payment_modalDeleteCard'
      );
    } else {
      cardHeading = isVenmo
        ? renderLabel(
            this.paymentGCLabels.lbl_payment_modalVenmoDelete,
            'lbl_payment_modalVenmoDelete'
          )
        : renderLabel(
            this.paymentGCLabels.lbl_payment_modalDeleteCard,
            'lbl_payment_modalDeleteCard'
          );
    }
    return (
      <DeleteCardModal
        openState={deleteModalMountedState}
        data={{
          heading: cardHeading,
          subHeading:
            selectedCard.ccType === 'VENMO'
              ? renderLabel(
                  this.paymentGCLabels.lbl_payment_modalVenmoDeleteHeading,
                  'lbl_payment_modalVenmoDeleteHeading'
                )
              : renderLabel(
                  this.paymentGCLabels.lbl_payment_modalGCHeading,
                  'lbl_payment_modalGCHeading'
                ),
          description: selectedCard,
          buttons: {
            cancel: renderLabel(
              this.paymentGCLabels.lbl_payment_modalGCCancel,
              'lbl_payment_modalGCCancel'
            ),
            confirm: renderLabel(
              this.paymentGCLabels.lbl_payment_modalGCConfirm,
              'lbl_payment_modalGCConfirm'
            ),
          },
          cardText: {
            cardEnd:
              selectedCard.ccType === 'VENMO'
                ? ''
                : renderLabel(
                    this.paymentGCLabels.lbl_payment_modalGCCardEnd,
                    'lbl_payment_modalGCCardEnd'
                  ),
            expire:
              selectedCard.ccType === 'VENMO'
                ? ''
                : renderLabel(this.paymentGCLabels.lbl_payment_gcExpire, 'lbl_payment_gcExpire'),
          },
        }}
        onDeleteCard={onDeleteCard}
        setDeleteModalMountState={setDeleteModalMountState}
        showUpdatedNotificationOnModal={showUpdatedNotificationOnModal}
        newGlobalErrorMessageEnabled={newGlobalErrorMessageEnabled}
      />
    );
  };

  render() {
    const {
      labels,
      className,
      showNotification,
      setDeleteModalMountState,
      creditCardList,
      giftCardList,
      cardList,
      onGetBalanceCard,
      checkbalanceValueInfo,
      setDefaultPaymentMethod,
      venmoCardList,
      showNotificationCaptcha,
      onDeleteCard,
      showUpdatedNotificationOnModal,
      addCreditCard,
      commonLabels,
      isRecapchaEnabled,
      newGlobalErrorMessageEnabled,
    } = this.props;
    return (
      <div className={className}>
        {showNotification && !newGlobalErrorMessageEnabled && (
          <Row fullBleed>
            <Col
              colSize={{
                small: 6,
                large: 12,
                medium: 8,
              }}
            >
              <Notification
                status={showNotification}
                colSize={{ large: 12, medium: 8, small: 6 }}
                message={
                  showNotification === 'success'
                    ? renderLabel(
                        this.paymentGCLabels.lbl_payment_successMsg,
                        'lbl_payment_successMsg'
                      )
                    : renderLabel(this.paymentGCLabels.lbl_payment_errorMsg, 'lbl_payment_errorMsg')
                }
              />
            </Col>
          </Row>
        )}
        <BodyCopy component="div" className="account-dashboard-goback-link">
          <Anchor
            fontSizeVariation="xlarge"
            anchorVariation="secondary"
            to="/account?id=account-overview"
            asPath="/account"
          >
            <span className="left-arrow" />
            {renderLabel(
              getLabelFromCopyOrFromTranslation(
                `${GLOBAL_ACTIONS_LABELS}.${lblBack}`,
                GlobalActionsLabels
              ),
              'lbl_back'
            )}
          </Anchor>
        </BodyCopy>
        <Row fullBleed>
          <Col
            colSize={{
              small: 6,
              large: 12,
              medium: 8,
            }}
          >
            <BodyCopy
              fontFamily="secondary"
              fontSize="fs16"
              fontWeight="extrabold"
              component="h4"
              className="payment__heading"
              data-locator="payment-payment&gcheader"
            >
              {renderLabel(this.paymentGCLabels.lbl_payment_heading, 'lbl_payment_heading')}
            </BodyCopy>
          </Col>
        </Row>
        {cardList && (
          <Row fullBleed>
            <Col
              colSize={{
                small: 6,
                large: 12,
                medium: 8,
              }}
            >
              <Offers labels={labels} className="payment__offers" />
            </Col>
          </Row>
        )}
        {creditCardList && (
          <CreditCardList
            creditCardList={creditCardList}
            className="payment__creditCard"
            setDeleteModalMountState={setDeleteModalMountState}
            onDeleteCard={onDeleteCard}
            showUpdatedNotificationOnModal={showUpdatedNotificationOnModal}
            showNotification={showNotification}
            setDefaultPaymentMethod={setDefaultPaymentMethod}
            setSelectedCard={this.setSelectedCard}
            addCreditCard={addCreditCard}
          />
        )}
        {venmoCardList && venmoCardList.size > 0 && (
          <VenmoCardList
            venmoCardList={venmoCardList}
            className="payment__venmoCard"
            setDeleteModalMountState={setDeleteModalMountState}
            onDeleteCard={onDeleteCard}
            showUpdatedNotificationOnModal={showUpdatedNotificationOnModal}
            showNotification={showNotification}
            onGetBalanceCard={onGetBalanceCard}
            checkbalanceValueInfo={checkbalanceValueInfo}
            showNotificationCaptcha={showNotificationCaptcha}
            setSelectedCard={this.setSelectedCard}
          />
        )}
        {giftCardList && (
          <GiftCardList
            commonLabels={commonLabels}
            giftCardList={giftCardList}
            className="payment__giftCard"
            setDeleteModalMountState={setDeleteModalMountState}
            onDeleteCard={onDeleteCard}
            showUpdatedNotificationOnModal={showUpdatedNotificationOnModal}
            showNotification={showNotification}
            onGetBalanceCard={onGetBalanceCard}
            checkbalanceValueInfo={checkbalanceValueInfo}
            showNotificationCaptcha={showNotificationCaptcha}
            setSelectedCard={this.setSelectedCard}
            isRecapchaEnabled={isRecapchaEnabled}
          />
        )}
        {this.renderDeleteModal()}
      </div>
    );
  }
}
PaymentView.defaultProps = {
  deleteModalMountedState: false,
};

PaymentView.propTypes = {
  labels: PropTypes.shape({}).isRequired,
  commonLabels: PropTypes.shape({}).isRequired,
  className: PropTypes.string.isRequired,
  showNotification: PropTypes.bool.isRequired,
  setDeleteModalMountState: PropTypes.func.isRequired,
  deleteModalMountedState: PropTypes.bool,
  onDeleteCard: PropTypes.func.isRequired,
  showUpdatedNotificationOnModal: PropTypes.string.isRequired,
  creditCardList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  giftCardList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  cardList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onGetBalanceCard: PropTypes.func.isRequired,
  checkbalanceValueInfo: PropTypes.string.isRequired,
  setDefaultPaymentMethod: PropTypes.func.isRequired,
  venmoCardList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  showNotificationCaptcha: PropTypes.bool.isRequired,
  addCreditCard: PropTypes.func.isRequired,
  isRecapchaEnabled: PropTypes.bool.isRequired,
};
export default withStyles(PaymentView, styles);
export { PaymentView as PaymentViewVanilla };
